var exports = {
  "n": "xa15a2ab7--18f1ca--link",
};

module.exports = exports;
